import SharedFileUploaderModal from "Components/FileUploaderModal/FileUploaderModal";
import { useFileUploaderModal } from "./useFileUploaderModal";
import { usePurchaseOrders } from "../../../../usePurchaseOrders";
import { useImportPricesPreviewModal } from "../../../ImportPricesPreviewModal/useImportPricesPreviewModal";
import { parseOrderAmount } from "../../../../orderAmount";

const isExcel = (name = "") => /\.(xlsx|xls)$/i.test(name);

function FileUploaderModal() {
  const { display, closeModal, vendorId, vendorIndex, vendorName } =
    useFileUploaderModal();

  const uploadPath = `${process.env.REACT_APP_API}/api/upload`;

  const handleUploaded = (data) => {
    // Always attach the quotation file to the vendor (existing behaviour).
    usePurchaseOrders
      .getState()
      .attachQuotationFiles(vendorId, vendorIndex, vendorName, data);

    // If it's an Excel quotation, offer to import its prices into the
    // vendor's price column (parse → preview → confirm).
    const file = Array.isArray(data) ? data[0] : data;
    const fileName = file?.fileName || file?.name || "";
    const url = file?.url;
    if (url && isExcel(fileName)) {
      const { form } = usePurchaseOrders.getState();
      const vendor = (form?.vendors || []).find(
        (v) => v.vendorIndex === vendorIndex || v.id === vendorId,
      );
      const currency = parseOrderAmount(vendor?.orderAmount).currency || "USD";
      useImportPricesPreviewModal.getState().startImport({
        purchaseOrderId: form?._id,
        vendor: { vendorIndex, vendorId, vendorName, currency },
        url,
      });
    }
  };

  return (
    <SharedFileUploaderModal
      display={display}
      onClose={closeModal}
      uploadPath={uploadPath}
      multiple={false}
      subtitle={vendorName ? `Quotation files for ${vendorName}` : "Select files to upload"}
      onUploaded={handleUploaded}
    />
  );
}

export default FileUploaderModal;
